import GlobalsContext from "../context/GlobalsContext";
import { useContext, useMemo } from "react";

const cat2reasonGroup = {
  // ex
  1: 2,
  // media
  2: 3,
  // goods
  4: 1
};

export default function useCategoryRejectReasons(cat_id) {
  const globalsContext = useContext(GlobalsContext);
  let rejectReasons = [];

  let group = useMemo(() => {
    const cat = globalsContext.categories.find(cat => cat.value == cat_id);
    if (cat) {
      return cat.group;
    }
  }, [cat_id]);

  if (group) {
    rejectReasons = globalsContext.reject_reasons[cat2reasonGroup[group]];
  }

  return rejectReasons;
}
